import { TFunction } from 'i18next';
import { IDashboardWidgetBaseConfiguration } from '../../../types/IDashboardWidgetBaseConfiguration';

export class AverageCycleCountWidgetConfiguration implements IDashboardWidgetBaseConfiguration {
  title = 'dashboard.averageCycleCountWidgetConfiguration.title';

  // Required filters
  assetTypeId?: number;
  // The cycle starting point is either a location or one or more label values (one or the other).
  cycleStartLocationId?: number;
  cycleStartLabelValueIds?: number[] = [];

  // Optional filters
  currentLocationId?: number;
  currentLabelValueIds?: number[] = [];
  startDateUTC?: string;
  endDateUTC?: string;

  constructor(t: TFunction) {
    this.title = t(this.title);
  }
}
